<div
  class="sectionContainer paddedContent containerMargins"
  style="background-color: #ffffff"
>
  @if (chartType == 'pie') {
    <app-pie-chart #theChart [label]="'Card Types'"></app-pie-chart>
  }
</div>
